import React, { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

// Small live indicator of session health, shown in the profile block.
//  - green  : session comfortably active (> 30 min left, refreshed while you work)
//  - orange : session about to expire (< 30 min) — happens only after long inactivity
const WARN_MS = 30 * 60 * 1000;

export const SessionStatusDot = ({ className = "" }) => {
  const { sessionExpiresAt } = useAuth();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 30 * 1000);
    return () => clearInterval(t);
  }, []);

  if (!sessionExpiresAt) return null;
  const remaining = new Date(sessionExpiresAt).getTime() - now;
  if (Number.isNaN(remaining)) return null;

  const warn = remaining <= WARN_MS;
  const color = warn ? "#FFB020" : "#00E5A0";
  const mins = Math.max(0, Math.round(remaining / 60000));
  const title = warn
    ? `Session bientôt expirée (~${mins} min) — bougez la souris ou rechargez pour la prolonger`
    : "Session active — prolongée automatiquement pendant que vous travaillez";

  return (
    <span
      data-testid="session-status-dot"
      title={title}
      className={`relative inline-flex w-2.5 h-2.5 shrink-0 ${className}`}
    >
      <span
        className={`absolute inset-0 rounded-full ${warn ? "animate-ping" : ""}`}
        style={{ backgroundColor: color, opacity: warn ? 0.5 : 0 }}
      />
      <span className="relative inline-flex w-2.5 h-2.5 rounded-full" style={{ backgroundColor: color, boxShadow: `0 0 8px ${color}` }} />
    </span>
  );
};
